(ns teamoesterreich.admin-mode.lebensretter.lr-feed.lr-feed
  (:require [clojure.string]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.admin-mode.actions :as a]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.lr-feeds :as d-lr-feeds]

            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]


            [teamoesterreich.admin-mode.ui-helper.editable-markdown-card :as edit-md-card]
            [teamoesterreich.admin-mode.ui-helper.image-drop-upload :as image-drop-upload]
            [teamoesterreich.admin-mode.ui-helper.block-edit-card :as block-edit-card]


            [reagent-material-ui.icons.delete-forever :refer [delete-forever]]
            [reagent-material-ui.icons.save :refer [save]]

            ))


(defn datetime-conv-back [dateTime]
  ;2021-06-20T23:24 -> 20180701T100000.000Z
  (str (subs dateTime 0 4) (subs dateTime 5 7) (subs dateTime 8 10) "T" (subs dateTime 11 13) (subs dateTime 14 16) "00.000Z"))



(defn datetime-conv [dateTime]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  (if (> (count dateTime) 12)
    (str (subs dateTime 0 4) "-" (subs dateTime 4 6) "-" (subs dateTime 6 8) "T" (subs dateTime 9 11) ":" (subs dateTime 11 13)
         )
    ""
    ))

(defn get-it []
  (let [!form-data (r/atom {})]
    (fn []
      (let [!lr-feeds-list (r/cursor vstate/app-state [:lrFeedItem-list])
            !loaded (r/cursor !lr-feeds-list [:loaded])
            !opened  (r/cursor !lr-feeds-list [:opened])
            !data (r/cursor !lr-feeds-list [:data @!opened])
            !publish-popup (r/cursor !lr-feeds-list [:show-publish-popup])
            !delete-popup (r/cursor !lr-feeds-list [:show-delete-popup])
            reload-fn #(reset! !loaded false)


            changed? (fn [key]
                       (log/debug "changed?" key (exists? (get @!form-data key)) (not= (get @!form-data key) (get @!data key)))
                       (and (exists? (get @!form-data key)) (not= (get @!form-data key) (get @!data key))))
            has-changes? (or
                           (changed? :lrFeedItem-title)
                           (changed? :lrFeedItem-date)
                           )
            change-fn (fn [key value]
                        (log/debug "change " key value)
                        (swap! !form-data assoc key value))
            ]
        (when-not @!loaded
          (do
            (d-lr-feeds/get-lr-feed-item-list
              (fn [response]
                (swap! !lr-feeds-list assoc :loaded true :data response)))
            [mui/paper
             [:br]
             [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
             [mui/typography {} "Lade Daten ... "]
             ]
            ))
        (log/debug "Feed edit" @!data @!loaded @!form-data)
        [mui/grid
         {:container  true
          :direction  "row"
          :alignItems "stretch"
          :justify    "flex-start"
          :style {:textAlign "left" :marginBottom "50px"}
          }
         [mui/grid
          {:item  true
           :xs    12
           :style {:height "50px"}
           }
          [mui/typography {:variant "h5" :style {:margin "12px 0 0 400px"}
                           :onClick reload-fn}
           "Lebensretter Feed Eintrag"]]

         [are-you-sure-modal/are-you-sure-modal !publish-popup
          "Bist du sicher, dass du diesen Eintrag veröffentlichen möchtest? Alle Mitglieder werden diesen Eintrag sehen können!" "Ja veröffentlichen"
          (fn [_] (d-lr-feeds/>lr-feed-item-edit @!opened {:lrFeedItem-published true}  reload-fn)) ]
         [are-you-sure-modal/are-you-sure-modal !delete-popup
          "Bist du sicher, dass du diesen Eintrag löschen möchtest? " "Ja löschen"
          (fn [_]
            (d-lr-feeds/>lr-feed-item-edit @!opened {:lrFeedItem-active false} reload-fn)
            (a/set-page :lebensretter-feeds)
            ) ]


         [mui/grid
          {:container false
           :item true
           :xl 7
           :xs 12  ;extra-small: 0px
           }

          [mui/card
           [mui/card-header
            {:title (str (:lrFeedItem-title @!data))}]


           [mui/card-content


            [mui/card
             [mui/card-content
              [mui/grid
               {:container  true
                :direction  "row"
                :alignItems "stretch"
                :justify    "flex-start"
                :style {:textAlign "left"}
                }
              [mui/grid
               {:container false :item true
                :xs        12                                  ;extra-small: 0px
                :style     {:padding "5px"}
                }
               [(image-drop-upload/get-it (:lrFeedItem-thumbnail @!data)
                                          (fn [new-url]
                                            (d-lr-feeds/>lr-feed-item-edit-img (:lrFeedItem-uuid @!data) new-url reload-fn))
                                          {:width 400 :max-height 400})]
               [:br]
               [:span "Ideale Größe ist 420x200 px "]
               ]

              [mui/grid
               {:container false :item true
                :xs        12                                  ;extra-small: 0px
                :style     {:padding "5px"}
                }
               [mui/text-field {
                                :style        {:backgroundColor (if (changed? :lrFeedItem-title) "#ffd6d2" "#ffffff")}
                                :fullWidth    true
                                :InputLabelProps {:disableAnimation true :shrink true}
                                ;:disabled     (not @!edit-mode)
                                :defaultValue (str (:lrFeedItem-title @!data))
                                :onChange     (fn [e] (change-fn :lrFeedItem-title (h/event-value e)))
                                :label        "Eintrag Titel"}]
               ]

              [mui/grid
               {:container false :item true
                :md        3                                   ;medium: 960px
                :xs        12                                  ;extra-small: 0px
                :style     {:padding "5px"}
                }

               [mui/text-field {
                                :style        {:backgroundColor (if (changed? :lrFeedItem-date) "#ffd6d2" "#ffffff")}
                                :fullWidth    true
                                :InputLabelProps {:disableAnimation true :shrink true}
                                :type         "datetime-local"
                                :autoOk       true
                                :label        "Eintrag Von-Datum"
                                :onChange     (fn [e]
                                                (let [date (h/event-value e)
                                                      date (datetime-conv-back date)]
                                                  (change-fn :lrFeedItem-date date)))
                                :defaultValue (datetime-conv (:lrFeedItem-date @!data))
                                }]
               ]
              ]
             [mui/card-actions
              [mui/button {
                           :variant   "contained"
                           :startIcon (r/as-element [keyboard-arrow-left])
                           :disabled (not has-changes?)

                           } "Abbrechen"]

              [mui/button {
                           :variant   "contained"
                           :color "primary"
                           :startIcon (r/as-element [save])
                           :disabled (not has-changes?)
                           :onClick (fn [] (d-lr-feeds/>lr-feed-item-edit (:lrFeedItem-uuid @!data) @!form-data reload-fn))
                           } "Speichern"]
              ]
             ]]]





           [mui/card-content {:style {:textAlign "left" }}
            [(block-edit-card/get-it (:lrFeedItem-description @!data)
                                     (fn [c] (d-lr-feeds/>lr-feed-item-edit (:lrFeedItem-uuid @!data) {:lrFeedItem-description c} (fn [] (log/debug "Reload after save...") (reload-fn))))
                                     {:title "Kurzer Text"})]
            ]


           [mui/card-content {:style {:textAlign "left" }}
            [(edit-md-card/get-it (:lrFeedItem-content @!data)
                                  (fn [c] (d-lr-feeds/>lr-feed-item-edit (:lrFeedItem-uuid @!data) {:lrFeedItem-content c} (fn [] (log/debug "Reload after save...") (reload-fn))))
                                  (str backend/BASE_URL "/media-upload")
                                  "Inhalt")]
            ]


           [mui/card-actions

            [mui/button {:startIcon (r/as-element [keyboard-arrow-left])
                         :onClick   (fn []
                                      (reset! !opened nil)
                                      (a/set-page :lebensretter-feeds))
                         }
             "Schließen"
             ]
            [mui/form-group
             [mui/form-control-label
              {:style {:paddingLeft "126px"}
               :label "Eintrag veröffentlichen"
               :fullWidth true
               :control (r/as-element
                          [mui/switch
                           {
                            :checked (or (get @!data :lrFeedItem-published) false)
                            :onChange (fn [_ v]
                                        (if v (reset! !publish-popup true)
                                              (d-lr-feeds/>lr-feed-item-edit @!opened {:lrFeedItem-published false}  reload-fn)))
                            }])}
              ]]

            [mui/button {:startIcon (r/as-element [delete-forever])
                         :onClick #(reset! !delete-popup true)
                         :color "secondary"
                         :style {:marginLeft "150px"}
                         }
             "Löschen"
             ]

            ]]]

         ]))
    ))